import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { getPatientReminderRecords } from "../connections/getApi";
import { setError, setLoading } from "../redux/slices/appointmentSlice";

const UsePatientReminderRecords = (patientId, prescriptionId) => {
    const dispatch = useDispatch();

    return useQuery({
        queryKey: ["getPatientReminderRecords", patientId, prescriptionId],
        queryFn: () => getPatientReminderRecords(patientId, prescriptionId),
        enabled: !!patientId && !!prescriptionId,
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: () => {
            dispatch(setError(true));
            dispatch(setLoading(false));
        },
        onSettled: () => {
            dispatch(setLoading(false));
        },
    });
};

export default UsePatientReminderRecords;
